module.exports = __webpack_public_path__ + "static/media/carta_31.31cc2208.jpg";